<script setup>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-3'
import { computed } from 'vue'
import { humanReadableTimestamp } from '@/composables/datetime'
import { useI18n } from 'vue-i18n'
import CustomNodeEditMenu from '@/components/wysiwyg-components/nodes/CustomNodeEditMenu.vue'
import DashboardCanvas from '@/components/dashboard-overview/DashboardCanvas.vue'

const props = defineProps(nodeViewProps)
const t = useI18n().t

let timestamp = null
if (props.node.attrs.timestamp !== null) {
  try {
    timestamp = parseInt(props.node.attrs.timestamp)
  } catch {}
}

const canvasId = props.node.attrs.canvasId || null
const imageSource = props.node.attrs.imageSource || 'stillFrame'

const chipText = computed(() => {
  return t('dashboards.titles.canvas_with_timestamp', { timestamp: humanReadableTimestamp(timestamp || Date.now()) })
})
</script>

<template>
  <node-view-wrapper
    as="div"
    class="d-inline-block"
  >
    <CustomNodeEditMenu
      :selected="props.selected"
      :variant-parameters="props.node.attrs"
      current-variant="inline-canvas"
      :variants="[
        { tag: 'inline-canvas', label: 'Inline', icon: 'mdi-text' },
        { tag: 'canvas', label: 'Canvas', icon: 'mdi-artboard' },
      ]"
      :node-props="props"
    >
      <template #element="nodeProps">
        <v-chip
          v-bind="nodeProps"
          append-icon="mdi-open-in-new"
        >
          {{ chipText }}
          <v-dialog
            activator="parent"
            width="100%"
          >
            <v-card width="100%">
              <DashboardCanvas
                :timestamp="timestamp"
                :canvas-id="canvasId"
                :preset-image-source="imageSource"
              />
            </v-card>
          </v-dialog>
        </v-chip>
      </template>
    </CustomNodeEditMenu>
  </node-view-wrapper>
</template>

<style scoped></style>
